export default __webpack_public_path__ + "node_modules/soulcycle-ui-kit/src/assets/fonts/helveticaneueltstdbdou.woff";